import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Toast } from "../CustomSwal";
import { createGroceryV2Item, deleteGroceryV2Favorite, loadGroceryV2Favorites } from "../../redux-components/actions/groceryV2Actions";

const GroceryV2FavoritesList = () => {
    const dispatch = useDispatch();
    const favoritesRef = useRef(null);

    const groceryV2FavoritesGet = useSelector(state => state.groceryV2FavoritesGet);
    const { loading: groceryV2FavoritesGetLoading, error: groceryV2FavoritesGetError, groceryV2Favorites } = groceryV2FavoritesGet;
    const editMode = useSelector((state) => state.editMode);

    const [favorites, setFavorites] = useState();
    const [openFavorites, setOpenFavorites] = useState(false);
    const [edit, setEdit] = useState(false);

    useEffect(() => {
        setEdit(editMode);
    }, [editMode]);

    useEffect(() => {
        if (!groceryV2FavoritesGetLoading) {
            setFavorites(groceryV2Favorites);
        }
    }, [groceryV2Favorites, groceryV2FavoritesGetLoading]);

    const addHandler = async (item_name) => {
        try {
            // Just dispatch the create action - the parent Dev.js component 
            // will handle optimistic updates
            await dispatch(createGroceryV2Item(item_name));
            setOpenFavorites(false);
            Toast.fire({
                icon: 'success',
                title: 'Item added to list'
            });
        } catch (e) {
            Toast.fire({
                icon: 'error',
                title: e.message
            });
        }
    }

    const removeHandler = async (item_desc) => {
        try {
            await dispatch(deleteGroceryV2Favorite(item_desc));
            // Reload favorites in background
            dispatch(loadGroceryV2Favorites());
            await Toast.fire({
                icon: 'success',
                title: 'Item removed from favorites'
            });
        } catch (e) {
            await Toast.fire({
                icon: 'error',
                title: e.message
            });
        }
    }

    const closeFavorites = () => {
        setOpenFavorites(false);
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (favoritesRef.current && !favoritesRef.current.contains(event.target)) {
                closeFavorites();
            }
        }

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        }
    }, []);

    return (
        <div ref={favoritesRef} className={'flex relative flex-col w-full rounded-md z-30'}>
            <h1 onClick={() => setOpenFavorites(!openFavorites)} 
                className={`border-black border-2 text-xl cursor-pointer text-black w-full rounded-md ${openFavorites ? "rounded-b-none bg-zinc-500 hover:bg-white text-white hover:text-black" : "rounded-b-md bg-white hover:bg-zinc-500 hover:text-white"}`}>
                Favorites
            </h1>
            <div className={`${openFavorites ? "flex absolute mt-7" : "hidden"} border-black border-2 border-t-0 p-2 flex-col w-full bg-zinc-500 rounded-md h-96 overflow-auto empty-scroll rounded-t-none`}>
                {favorites?.favorites?.map((item) =>
                    <div key={item} className={'flex flex-row content-center items-center justify-between p-1 space-x-2'}>
                        {edit && <div onClick={() => removeHandler(item)}
                              className={'flex items-center h-8 w-8 justify-center bg-red-500 hover:bg-red-600 hover:bg-white text-white cursor-pointer p-2 rounded-full'}>
                            <FontAwesomeIcon icon={'fas fa-x'} size={'xl'}/>
                        </div>}
                        <div key={item} onClick={() => addHandler(item)} 
                             className={'border-black border-2 hover:bg-zinc-400 cursor-pointer flex space-x-2 touch-manipulation flex-row p-4 bg-zinc-300 text-black rounded-md w-full content-center justify-between items-center'}>
                            <p className={'text-center flex-grow'}>{item}</p>
                        </div>
                    </div>
                )}
                {(!favorites?.favorites || favorites.favorites.length === 0) && (
                    <div className="text-white text-center p-4">
                        No favorites yet. Add items to favorites by clicking the heart icon.
                    </div>
                )}
            </div>
        </div>
    );
};

export default GroceryV2FavoritesList;
